import React, { useState } from "react";
import { Form, FormGroup, Label } from "reactstrap";
import SapButton from "../../../components/SapButton";
import HiddenTextInput from "../../../components/HiddenTextInput";

interface Props {
    onSubmit: (password: string) => void;
    isSubmitting?: boolean;
}

export function PasswordInput({ onSubmit, isSubmitting }: Props) {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");

    const validatePassword = (pwd: string) => {
        const hasUpperCase = /[A-Z]/.test(pwd);
        const hasLowerCase = /[a-z]/.test(pwd);
        const hasNumber = /[0-9]/.test(pwd);
        return hasUpperCase && hasLowerCase && hasNumber;
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError("Passwords do not match.");
        } else if (!validatePassword(password)) {
            setError("Password must contain at least one uppercase letter, one lowercase letter, and one number.");
        } else {
            setError("");
            onSubmit(password);
        }
    };

    return (
        <Form onSubmit={handleSubmit}>
            <FormGroup>
                <Label>Password:</Label>
                <HiddenTextInput value={password} onChange={(value) => setPassword(value)} />
                <small className="text-muted">
                    Password must contain at least one uppercase letter, one lowercase letter, and one number.
                </small>
            </FormGroup>
            <FormGroup>
                <Label>Confirm Password:</Label>
                <HiddenTextInput value={confirmPassword} onChange={(value) => setConfirmPassword(value)} />
            </FormGroup>
            {error && <p className="text-danger">{error}</p>}
            <FormGroup>
                <SapButton
                    color="primary"
                    type="submit"
                    submitting={isSubmitting}
                    disabled={!password || !confirmPassword}
                >
                    Submit
                </SapButton>
            </FormGroup>
        </Form>
    );
}
